var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "371.9 181.2 856.2 1236.5",
    style: {
      enableBackground: "new 371.9 181.2 856.2 1236.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--hover-color, #009ACA)}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1210.3,181.2H502.3c-71.9,0-130.4,58.5-130.4,130.4v877.9c0,71.9,58.5,130.4,130.4,130.4h142.9v81 c0,6.7,3.8,12.9,9.8,15.9h0c2.5,1.3,5.3,1.9,8,1.9c3.7,0,7.5-1.2,10.6-3.5l87.8-65.1l87.8,65.1c5.4,4,12.6,4.6,18.6,1.6 c6-3,9.8-9.2,9.8-15.9v-81h332.6c9.8,0,17.8-8,17.8-17.8l0-232.6V199C1228.1,189.2,1220.1,181.2,1210.3,181.2z M502.3,216.8h690.2 v835H502.4c-37.4,0-71.1,15.9-94.9,41.2l0-781.4C407.5,259.3,450,216.8,502.3,216.8z M772,1313.7c-6.3-4.7-14.9-4.7-21.2,0 l-70,51.9v-63.4c0,0,0,0,0,0c0,0,0,0,0,0v-84.7h161.3l0,148.2L772,1313.7z M1192.5,1284.3H877.7v-67h55c9.8,0,17.8-8,17.8-17.8 s-8-17.8-17.8-17.8H590.3c-9.8,0-17.8,7.9-17.8,17.8s8,17.8,17.8,17.8h55v67l-142.9,0c-52.3,0-94.9-42.5-94.9-94.9v-7.3 c0-52.3,42.5-94.9,94.9-94.9h690.2V1284.3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1192.5,1087.3v197H877.7v-67h55c9.8,0,17.8-8,17.8-17.8s-8-17.8-17.8-17.8H590.3c-9.8,0-17.8,7.9-17.8,17.8 s8,17.8,17.8,17.8h55v67l-142.9,0c-52.3,0-94.9-42.5-94.9-94.9v-7.3c0-52.3,42.5-94.9,94.9-94.9H1192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502.3,216.8c-52.3,0-94.9,42.6-94.9,94.9l0,781.4c23.8-25.3,57.5-41.2,94.9-41.2h690.1v-835H502.3z  M1046.5,573.4c0,9.8-8,17.8-17.8,17.8H606.9c-9.8,0-17.8-8-17.8-17.8v-189c0-9.8,8-17.8,17.8-17.8l421.8,0 c9.8,0,17.8,8,17.8,17.8V573.4z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.7,366.6l-421.8,0c-9.8,0-17.8,8-17.8,17.8v189c0,9.8,8,17.8,17.8,17.8h421.8c9.8,0,17.8-8,17.8-17.8v-189 C1046.5,374.6,1038.5,366.6,1028.7,366.6z M1010.9,555.6H624.7V402.2h386.3V555.6z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/glossary.218ef40ae6d1df1ac67534542def863f.svg";
export { ForwardRef as ReactComponent };